/***********************************
 * NOTE: This script uses an outdated setup for actions/reducers.
 * We are now using @reduxjs/toolkit to simplify this. This script will eventually be migrated.
 * If you are setting up a new Redux view model, follow the example of the WorksheetEditor scripts instead.
 ***********************************/

import * as actions from './actions';
import * as oPath from '../../../Lib/Object/Path/Immutable';

const defaultState = {};

const gridScrollLinkReducer = (state = defaultState, { type, id, scrollLinkId, position }) => {
  switch (type) {
    case actions.GRIDSCROLLLINK_INIT:
      return oPath.set(state, scrollLinkId, position);

    case actions.GRIDSCROLLLINK_CLEANUP:
      return oPath.del(state, scrollLinkId);

    case actions.GRIDSCROLLLINK_SET_POSITION:
      return oPath.setMultiple(state, '', { [scrollLinkId]: position, lastChangedBy: id });

    default:
      return state;
  }
};

export default gridScrollLinkReducer;
